import { render, staticRenderFns } from "./TopAssetStock.vue?vue&type=template&id=3521d7c0&scoped=true"
import script from "./TopAssetStock.vue?vue&type=script&lang=js"
export * from "./TopAssetStock.vue?vue&type=script&lang=js"
import style0 from "./TopAssetStock.vue?vue&type=style&index=0&id=3521d7c0&prod&lang=css"
import style1 from "./TopAssetStock.vue?vue&type=style&index=1&id=3521d7c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3521d7c0",
  null
  
)

export default component.exports